import React from 'react';
import CustomerPreferences from './customer_preferences'
import LessonOrderSummary from './summary'
import PricingCalculator from './pricing_calculator/show'
import store from '../../../../../state/store'

class LessonOrder extends React.Component {

  componentDidMount() {
    store.emit('pricing_calculator:initialize', this.props.lesson_order)
  }

  onSave = () => {
    store.emit('lesson_plan:lesson_order:save', this.props.lesson_plan.id, this.props.lesson_order.id, this.props.pricing_calculator.inputs)
  }

  onPlace = () => {
    if (this.props.lesson_order.workflow_state == 'placing') {
      store.emit('lesson_plan:lesson_order:place', this.props.lesson_plan.id, this.props.lesson_order.id, this.props.pricing_calculator.inputs)
    }
  }
  
  onAdd = (order_id) => {
    const getParams = {
      order_id: order_id,
      ...this.props.pricing_calculator.inputs
    }

    if (this.props.lesson_order.workflow_state == 'placing') {
      store.emit('lesson_plan:lesson_order:add_to_order', this.props.lesson_plan.id, this.props.lesson_order.id, getParams)
    }
  }

  onUpdate = () => {
    store.emit('lesson_plan:finalised_lesson_order:update', this.props.lesson_plan.id, this.props.lesson_order.id, this.props.lesson_order.active_order.id, this.props.pricing_calculator.inputs)
  }

  onPricingCalculatorUpdate = (params = {}) => {
    store.emit('pricing_calculator:inputs:update', params)
  }

  render() {
    const lesson_order = this.props.lesson_order

    return (
      <div className="flex flex-col gap-4">
        {lesson_order.customer_preferences ?
          <CustomerPreferences lesson_order={lesson_order} lesson_plan={this.props.lesson_plan} />
          : null
        }
        <LessonOrderSummary lesson_order={lesson_order} lesson_plan={this.props.lesson_plan} />
        <PricingCalculator
          pricing_calculator={this.props.pricing_calculator}
          lesson_order={this.props.lesson_order}
          change_applied={this.props.change_applied}
          onUpdate={this.onPricingCalculatorUpdate}
          onAddToOrder={this.onAdd}
          onSaveLessonOrder={this.onSave}
          onUpdateOrder={this.onUpdate}
          onPlaceOrder={this.onPlace}
        />
      </div>
    );
  }
}

export default LessonOrder